export default {
    namespaced: true,
    state: {
        users: []
    },
    mutations: {
        setUsers(state, usersInfo) {
            state.users = usersInfo;
        },
        clearUsers(state) {
            state.users = [];
        },
        addUser(state, addedUserInfo) {
            // Make sure the user is not already in the array : add only if not yet
            if (!state.users.some((user) => user.id == addedUserInfo.id)) {
                state.users.push(addedUserInfo);
            }
        },
        removeUser(state, removedUserId) {
            state.users = state.users.filter((user) => user.id !== removedUserId)
        }
    },
    getters: {
        isEmpty: state => !state.users.count>0
    }
};